import React from "react";
// import { useState } from 'react';
// import "../styles/audioplayer.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
const reorder = (list, startindex, endindex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startindex, 1)
    result.splice(endindex, 0, removed)

    return result;
};

export default class AudioPlayer extends React.Component {
    state = {
        index: 1,
        currentTime: '0:00',
        musicList: [
            { audio: 'https://www.bensound.com/bensound-music/bensound-buddy.mp3', id: "0", img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIADYASAMBIgACEQEDEQH/xAAbAAEAAgMBAQAAAAAAAAAAAAAABAYDBQcCAf/EADUQAAEEAQEEBwUIAwAAAAAAAAEAAgMEEQUSITFRBhMUFUFUkiIjM2FxBzJTgYKRocFCUmL/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOL93XfLSelfe7bvlpPSregQVMaNqR4UZz+godH1IcaU4/QrrJcbXiL3k48APEqRC2W0K0Qi66za+FCCQ0Dm443j+EHPzp1wHBrvB5L13RqHlJf2XSdU6IX4KgZHNTY4tw5scOM896rdJ8um3OxTyNkiLtkEH7rvogrfdGo+Tl9K8d23fLSeldBwtceJQU7u675aT0r6reiAiIOKCd0godlpUBHA54tsZILTne7a7cS36+G/l+1m6ANaLF63ZiaLIeIcneQAN+Pr/SjdFL0L2yaPqEbZatk+y1/AOWo1YydF+lHZn2nGlYYGvdnLmtO7JzxI5+IQWnpFrrbNa3FobmWbcY9rY9rYHicfJc91bSpuxW9QmNoFkjQx87NkyeBOFf8AR6Pdkj5orsVrMbWV4WRhjeeXHxJ8Sqvqti7NTt0r5if1shEXU/Didv8AYDjjaIx4ZwiIOi2+1VR1jsyM3OPPkV4PE/VaTSb4ozudI0ljhg44hbrOd/NFEREBBxWPtEP40frCCeHI99H6wg33R6MO13T2PGczjdzxv/pYPtbDm6zC7/FzOPzCm9GJqh6UU3SWa7YoI5ZS90rQA7AaBx/6Kj/afap2LleaGevYEbgS1sgcHDkcIK/ous6lpzSwV5Zomu2NktOWHl/I3fMKTqGvPnaWUtLdDbLMOleC9zGcMMB3NGeS0bNVDZorDoWGaNxJcJNzsgNOQc+DQOP5L4L9cR7HZx8PqydtnDa2uGxjj8kENzHBm0WkNPA43Kzt+6Poqy6ZnVbDcAcTl2clWJs8OyPfR8P9wgyosfaIfxo/WEQUlERAREQEREBERAREQf/Z", name: "Rolling in the Deep", author: "Adele", duration: "3:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-slowmotion.mp3', id: "1", img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAEgASAMBIgACEQEDEQH/xAAbAAABBAMAAAAAAAAAAAAAAAAAAQIEBQMGB//EADcQAAIBAwIEAwQIBgMAAAAAAAECAwAEEQUSEyExUQYiQRQyYZFCcYGhscHR8DRSZKLh8QcVM//EABUBAQEAAAAAAAAAAAAAAAAAAAAC/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A5NRmkpKlR2TWyeHdkDqSM58xJPX/AB+pPatbQZYVe24ePhWowskpDSH+Udv32oN6lu8aZw7YhGk53Fyc4jX+VR6sfn+Wn6vql0q+z2ErR26eXyooyf1rLe6g2o3kOmwSbYUOCR/cx7n/AFW5eBdFtbxpNRkhHslsxjt4zzJYdXY+p9PnQcuutLv4FWS6gkTeNwL9cVBIKnFdN/5NuFYjaMc+VcyY5JoHq6CF0MKs5ORJuOV+zpRWOigWiirPT7GCK1XU9WV/Y9xWCBW2veOOoB+ig+k/2Dn0B+gabcXTm6EaraxNh7iZxHGG67dzEAn4Dn8Ktdc0WfSbgrqdzwbiRdzJGM7R23fZjl2qLY3slxM+t6qENhpwCwWqDZEz+8kEa+i8tzHrtBJJJBOw+PtSjt9Tiv7hUnv2gVrVJBuSFT5uM4PJmyTtU5AxuPoCGpaGOHqhQHIKsoP5/IV1JNQl8J+C7ZV9mV+FljMWOZHJYgAD49652tl/0xa9vXbjRFY5E/qH8zJ0+hGct2ZgvxroHiWaxurKP2qNZYNvQgHBxyPOg5prfiG51j+JjRSD1TNU5yOtT5bWe/1SSOzg4ryP5Vhj2j5dB+FZvEekzaPc21tc/wDq1sruOxJPL7qCpooooFq7sdGtdSj4y65DBbW8am5N1DLut1J5hQqlW8xbaoYFuw54qLeNZZ0jkmWFCfNK4JCD1OBzP1ep5VPklk1Oaz0fS0MVs06pbxyEZklcheJIR1Y5+pRyHqSF1enT7S0g1UTQXFnbs8GlWHDk2M4ILSSb1XfgkFuWGbavujAS2F5qGsHUbndfXVmkKIr4PtF6/KJPTPmyx7iNvQ1J0/WfDkMl48ytIYUNlpyva8dRbgY3qpwu92Ls24jmwxkbgZdnqmhw6gtlazXJj4jIrhcPvlGJZ9xAGVTESDGc5blmg1rXWF5eJZWtwbiGzDxRyFieO+S0sxJ6l3yR8No9KkpqT3VnHbu5yqgH44rJ4rk0i1uILbSLKOG4tpDxJYVdIyg91MMzFyPV/LnsetUczGN1ni5A/d+/yoLfQLn2TXLZiziJX3PsGSQOeMfHpR481OLVtaS4gSRE4CjEow2eeeXpVfZ3xhDSCIMwHq+KgXEzXE7yye85yaDHRRRQFPhlkgmSaFyksbBkdTgqR6im0lA+Dyyx4HJWH3VnlZVDJENxb33P4Co6nANLlnIUAkk4CgdTQNJOBz5U9XYDBJ245g03acZwcd8Uq5UhipxntQZZhEsaiPmxHNgaj1mBjYkONvYimSIY2KsKBlFLRQFFFFAU6OR42DxOyMOjKcEfbRRQKJZQoXiPtAIC7jjB6j6jS7nkBDyOQTk5YnJ7/XS0UEqG2hWAvcbuZ8pA5YqPMNwBzgAYGe1JRQYaKKKD/9k=", name: "When We Were Young", author: "Adele", duration: "4:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-slowmotion.mp3', id: "2", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksgUBCNDVALchQAdWcQ3MmpfK9B54UKzXWw&usqp=CAU", name: "Cry Your Heart Out", author: "Adele", duration: "3:21" },
            // { audio: 'https://www.bensound.com/bensound-music/bensound-slowmotion.mp3', id: "3", img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIADYASAMBIgACEQEDEQH/xAAcAAEAAQQDAAAAAAAAAAAAAAAABgMEBQcBAgj/xAAzEAABAwIFAQMKBwAAAAAAAAABAAIDBBEFBhIhMRNRcZEUFSIjMkFTVGGSB0JzgaGx8f/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/EABkRAQEBAAMAAAAAAAAAAAAAAAABEQISMf/aAAwDAQACEQMRAD8A0v5vrPl5PBPN9Z8vJ4KWIeCs6cQ7yab4bllaPKeYK6PqUmEVcrO1savMNjbJWwseLs1Xd3LfmUmCOiiFuWg2ReRxoAZDzWRcYBXW/SVGpydmSlYX1GDVjGjkmNerAWgWIWKxdjTE+7drI7rHlaow2upiBUUssZIuNTbXC4831ny8ngppnhxbjM0V/RbwOwK3HAWpyWIn5vrPl5PBFLEVowQ8FE527UFY4TC+fEIYme047f2p9h9VWPmDcMixGnkjcWOlE2sXAubse/jubfsUPw4MwzGqKV7tXpXJH1/1bkpzhjaR+IsgiE5Zcy6dxssUxWZW19Zl8ztkdBUtLmPdG3U5pb7RAPd/KilJW1MtfHTz0tfJJI8tE0tRdwI9/ovIA/aylWXaiE4RTSiWN3VmfdocCST7rLKSxUFBE+engiY4i5c1oCC0l+IdFLDjLpCCW9Noc767rHjgLP55xmCqpp6Vj/XyVDXvbp4jA23791gBwFueCiIiQIV068PxY/uCdeIbiWO439oKStWYfNNC2ZjS57W76d9x7+5TPAcYazL7pdIlGm2i43J926gNXmGqqHNf1IoZGnd8IDC7vsq2X8wjDa3XVWnpnuvIy48Qs2U7G08v14ooWGLApI/zPeHM3Pbz9VlccrG+RPlm9TEG6najwLX3Ubgz5kmEAsp9Lg3Ytpzz2cKF5tztJjjxDSN8momuvoLhqfbi9uB9EZVsWFXG+vmqq17S3qvJDTtZo4HfsAuRwFZRYu5kMjXdN8jvZe63o93YrkTw2HrY/uC1IFRF068PxY/uCJSGIiLbIiIpCIikIiKQiIpP/9k=", name: "Send My Love", author: "Adele", duration: "7:58" },
            { audio: 'https://cdn.simplecast.com/audio/17ba21/17ba21db-66b5-4612-855e-556b20f60155/6cd39874-c070-417b-8cd0-481cb8c6e866/Undefined_E9_Nader_tc.mp3', id: "4", img: "https://images-na.ssl-images-amazon.com/images/I/71X-290hdOL.jpg", name: "Make You Feel Love", author: "Adele", duration: "1:21" },
            { audio: 'https://cdn.simplecast.com/audio/17ba21/17ba21db-66b5-4612-855e-556b20f60155/6cd39874-c070-417b-8cd0-481cb8c6e866/Undefined_E9_Nader_tc.mp3', id: "5", img: "https://images.macrumors.com/t/U1y2-rMrcY1n8mKlIGE8XYbWAKM=/1600x1200/smart/article-new/2015/11/adele.jpg", name: "Someone Like You", author: "Adele", duration: "11:21" }],
        pause: false,
        currentDroppable: null,
        showMenu: false,
        showSearchbox: false,
        value: 0,
        //  audio: new Audio("https://cdn.simplecast.com/audio/17ba21/17ba21db-66b5-4612-855e-556b20f60155/6cd39874-c070-417b-8cd0-481cb8c6e866/Undefined_E9_Nader_tc.mp3"),
        isPlaying: false,
        repeat: false,
        showVolume: false,
        isRepeat: false,
        isActive: false,
        isShuffle: false,
        search_results: false
    };
    handleClick = () => {
        this.setState({ showMenu: !this.state.showMenu })

    }
    handleVolume = () => {
        this.setState({ showVolume: !this.state.showVolume })

    }

    handleSearch = () => {
        this.setState({ showSearchbox: !this.state.showSearchbox, search_results: false })
        console.log(this.state.showSearchbox)

    }

    getInitialState = () => {
        return { value: 0, value2: 0 };
    }
    handleChange = (event) => {
        this.setState({ value: event.target.value2 });
    }
    handleChangevolume = (e) => {
        this.setState({ value: e.target.value });
    }

    goForwardBackward = (time) => {

        if (time == 'back') {
            // changes
            this.state.playerRef.currentTime = this.state.playerRef.currentTime - 10;
        } else if (time == 'fwd') {
            // changes
            this.state.playerRef.currentTime = this.state.playerRef.currentTime + 10;
        }
    }

    repeat = (time) => {

        if (time == 'repeat') {
            // changes
            this.state.isRepeat = !this.state.isRepeat
            this.playerRef.currentTime = -this.playerRef.currentTime;
            // let bound = this.timelineRef.getBoundingClientRect()
            // let percentage = ((e.clientX - bound.left)/bound.width)*100
            this.playheadRef.style.width = 100 + "%";

        }
    }

    componentDidMount() {
        this.playerRef.addEventListener("timeupdate", this.timeUpdate, false);
        this.playerRef.addEventListener("ended", () => {
            if (this.state.isRepeat) {
                console.log('hear');
                this.playerRef.currentTime -= this.playerRef.currentTime;
                this.playerRef.play();
            }
            else
                this.nextSong()
        }, false);
        this.timelineRef.addEventListener("click", this.changeCurrentTime, false);
        this.timelineRef.addEventListener("mousemove", this.hoverTimeLine, false);
        this.timelineRef.addEventListener("mouseout", this.resetTimeLine, false);
    }

    componentWillUnmount() {
        this.playerRef.removeEventListener("timeupdate", this.timeUpdate);
        this.playerRef.removeEventListener("ended", () => {
            if (this.state.isRepeat) {
                console.log('hear');
                this.playerRef.currentTime -= this.playerRef.currentTime;
                this.updatePlayer();

            }
            else
                this.nextSong()
        }
        );
        this.timelineRef.removeEventListener("click", this.changeCurrentTime);
        this.timelineRef.removeEventListener("mousemove", this.hoverTimeLine);
        this.timelineRef.removeEventListener("mouseout", this.resetTimeLine);
    }

    changeCurrentTime = (e) => {
        const duration = this.playerRef.duration;
        const playheadWidth = this.timelineRef.offsetWidth;
        const offsetWidht = this.timelineRef.offsetLeft;
        const userClickWidht = e.clientX / 2 - offsetWidht;

        const userClickWidhtInPercent = (userClickWidht * 100) / playheadWidth;

        let bound = this.timelineRef.getBoundingClientRect()

        let percentage = ((e.clientX - bound.left) / bound.width) * 100
        this.playheadRef.style.width = percentage + "%";
        this.playerRef.currentTime = (duration) * percentage / 100;
        console.log(bound)
    }

    hoverTimeLine = (e) => {
        const duration = this.playerRef.duration;

        const playheadWidth = this.timelineRef.offsetWidth

        const offsetWidht = this.timelineRef.offsetLeft;
        const userClickWidht = e.clientX - offsetWidht;
        const userClickWidhtInPercent = (userClickWidht * 100) / playheadWidth;

        if (userClickWidhtInPercent <= 100) {
            this.hoverPlayheadRef.style.width = userClickWidhtInPercent + "%";
        }

        const time = (duration * userClickWidhtInPercent) / 100;

        if ((time >= 0) && (time <= duration)) {
            this.hoverPlayheadRef.dataset.content = this.formatTime(time);
        }
    }
    resetTimeLine = () => {
        this.hoverPlayheadRef.style.width = 0;
    }

    timeUpdate = () => {
        const duration = this.playerRef.duration;
        const timelineWidth = this.timelineRef.offsetWidth - this.playheadRef.offsetWidth;
        const playPercent = 100 * (this.playerRef.currentTime / duration);
        this.playheadRef.style.width = playPercent + "%";
        const currentTime = this.formatTime(parseInt(this.playerRef.currentTime));
        this.setState({
            currentTime
        });
    }

    formatTime = (currentTime) => {
        const minutes = Math.floor(currentTime / 60);
        let seconds = Math.floor(currentTime % 60);

        seconds = (seconds >= 10) ? seconds : "0" + seconds % 60;

        const formatTime = minutes + ":" + seconds

        return formatTime;
    }


    updatePlayer = () => {
        const { musicList, index } = this.state;
        const currentSong = musicList[index];
        const audio = new Audio(currentSong.audio);
        this.playerRef.load();
    }
    nextSong = () => {
        const { musicList, index, pause } = this.state;
        const next_index = this.state.isShuffle ? Math.floor(Math.random() * musicList.length) : (index + 1) % musicList.length

        this.setState({
            index: next_index
        });
        this.updatePlayer();
        if (pause) {
            this.playerRef.play();
        }

    };

    prevSong = () => {
        const { musicList, index, pause } = this.state;
        const next_index = this.state.isShuffle ? Math.floor(Math.random() * musicList.length) : (index + musicList.length - 1) % musicList.length;
        this.setState({
            index: next_index
        });
        this.updatePlayer();
        if (pause) {
            this.playerRef.play();
        }
    };
    shuffle = () => {
        this.setState(
            {
                isShuffle: !this.state.isShuffle,
                isActive: !this.state.isActive
            }
        )
    }

    playOrPause = () => {
        const { musicList, index, pause } = this.state;
        const currentSong = musicList[index];
        const audio = new Audio(currentSong.audio);
        if (!this.state.pause) {
            this.playerRef.play();
        } else {
            this.playerRef.pause();
        }
        this.setState({
            pause: !pause
        })
    }

    clickAudio = (key) => {
        const { pause } = this.state;

        this.setState({
            index: key
        });

        this.updatePlayer();
        if (pause) {
            this.playerRef.play();
        }
    }

    filter = (e) => {
        // const [name, setName] = useState('');
        // const [foundUsers, setFoundUsers] = useState(this.state.musicList);
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = this.state.musicList.filter((user) => {
                return user.name.toLowerCase().startsWith(keyword.toLowerCase());
            });
            this.setState(
                {
                    search_results: results
                }
            )
        }
    };

    constructor(props) {
        super(props);
        this.onDragEnd = this.onDragEnd.bind(this)
    }

    onDragEnd(result) {
        if (!result.destination)
            return;

        const items = reorder(
            this.state.musicList,
            result.source.index,
            result.destination.index
        )
        this.setState(
            {
                musicList: items
            }
        )
    }

    dragStart = (e) => {
        let el = e.target.getBoundingClientRect()
        this.setState({
            initialData: {
                elWidth: el.width,
                elLeft: el.left
            }
        }, () => {
            window.addEventListener('mousemove', this.mouseMove);
            window.addEventListener('mouseup', this.mouseUp);

        })
        // e.dataTransfer.setData("Text", e.target.id);
    }
    mouseMove = (e) => {
        const duration = this.playerRef.duration;
        const playheadWidth = this.timelineRef.offsetWidth;
        const offsetWidht = this.timelineRef.offsetLeft;
        const userClickWidht = e.clientX / 2 - offsetWidht;

        const userClickWidhtInPercent = (userClickWidht * 100) / playheadWidth;

        let bound = this.timelineRef.getBoundingClientRect()

        let percentage = ((e.clientX - bound.left) / bound.width) * 100
        this.playheadRef.style.width = percentage + "%";
        this.playerRef.currentTime = (duration) * percentage / 100;

    }
    mouseUp = () => {
        window.removeEventListener("mousemove", this.mouseMove)
        window.removeEventListener("mouseup", this.mouseUp)

    }
    dragEnd = (e) => {

    }

    allowDrop = (event) => {
        event.preventDefault();
    }

    drop = (event) => {
        event.preventDefault();
        var data = event.dataTransfer.getData("Text");
        event.target.appendChild(document.getElementById(data));
    }

    render() {
        const { musicList, index, currentTime, pause } = this.state;
        const currentSong = musicList[index];
        return (

            <div className="h-100 scroll-no-scrollbar w-100">
                <div className='container box-shadow-widgets window-content-radius' style={{ borderRadius: "1rem" }} >

                    <div className="current window-content-radius" style={{ display: "flex", justifyContent: "center" }}>
                        <div>
                            <div className=" row1 m-0">
                                <div >
                                    <div className="currentlist">
                                        <img className="currentimage" src={currentSong.img}></img>
                                        <div className="currentdesc">
                                            <div style={{ display: "flex", flexDirection: "row", padding: ".5rem .5rem" }}>
                                                <div className="namedesc">
                                                    <p ><b style={{ lineHeight: "15px", fontSize: "12px" }}>{currentSong.name}</b></p>
                                                    <p style={{ color: "gray", marginTop: "2rem" }}>{currentSong.author}</p>
                                                </div>
                                                {this.state.showMenu ? (
                                                    <div className="menubar">

                                                        <svg xmlns="http://www.w3.org/2000/svg" onClick={() => this.handleClick()} cursor=" pointer" width="20" height="20" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                        </svg>
                                                        <button>Add to favorites</button>
                                                        <button>add to playlist</button>
                                                        <button>More</button>
                                                    </div>

                                                ) : null
                                                }
                                                <svg cursor=" pointer" onClick={() => this.handleClick()} xmlns="http://www.w3.org/2000/svg" transform="rotate(90)" width="20" height="20" fill="currentColor" className="bi bi-three-dots" viewBox="0 0 16 16">
                                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                                </svg>

                                            </div>
                                            <audio id="myAudio" ref={ref => this.playerRef = ref} >
                                                <source src={currentSong.audio} type="audio/ogg" />
                                            </audio>
                                            {/* <div className="menu">
                            <div className="topmenu"> */}
                                            {/* {this.state.showSearchbox ? (
                                    <div className="searchbar">
                                        <div className="alist">
                                         <input type="text" placeholder="search..." fontSize="smaller" onChange={() => this.inputHandler()}></input>
                                         <input type="search" className="input" onChange={this.filter} variant="outlined" fullWidth label="Search" placeholder="search..." />
                                        </div>
                                    </div>
                                ) : null
                                } */}
                                            {/* </div>

                        </div>  */}


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="range">
                                <div className="currentduration">
                                    <p  >{currentTime}</p>
                                    <p >{currentSong.duration}</p>
                                </div>
                                <div ref={ref => this.timelineRef = ref} id="timeline" className="droptarget" >
                                    <div ref={ref => this.playheadRef = ref} className="droptarget" id="playhead" style={{ width: "0%", position: 'relative' }}><div onMouseDownCapture={(e) => this.dragStart(e)} id="ball" className="thumb " style={{ right: 0 }} ref={ref => this.PlayheadRef = ref}></div></div>
                                    <div id="demo"></div>
                                    <div ref={ref => this.hoverPlayheadRef = ref} className="hover-playhead" data-content="0:00"></div>
                                </div>
                            </div>
                            <div className="svglist">
                                <div className="svg-groups">
                                    <svg xmlns="http://www.w3.org/2000/svg" style={{ color: this.state.isActive ? 'red' : '', marginRight: "1rem", cursor: " pointer" }} opacity="40%" width="23" height="23" fill="currentColor" className="bi bi-shuffle" viewBox="0 0 16 16" onClick={this.shuffle}>
                                        <path fillRule="evenodd" d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z" />
                                        <path d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z" />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" cursor=" pointer" style={{ color: this.state.isRepeat ? 'red' : '' }} opacity="40%" width="23" height="23" fill="currentColor" className="bi bi-repeat" viewBox="0 0 16 16" onClick={() => this.repeat("repeat")}
                                    >
                                        <path d="M11 5.466V4H5a4 4 0 0 0-3.584 5.777.5.5 0 1 1-.896.446A5 5 0 0 1 5 3h6V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192Zm3.81.086a.5.5 0 0 1 .67.225A5 5 0 0 1 11 13H5v1.466a.25.25 0 0 1-.41.192l-2.36-1.966a.25.25 0 0 1 0-.384l2.36-1.966a.25.25 0 0 1 .41.192V12h6a4 4 0 0 0 3.585-5.777.5.5 0 0 1 .225-.67Z" />
                                    </svg>
                                </div >

                                <div className="svg-groups">
                                    <svg xmlns="http://www.w3.org/2000/svg" transform="rotate(180)" cursor="pointer" width="28" height="28" fill="currentColor" className="bi bi-fast-forward-fill" viewBox="0 0 16 16" onClick={this.prevSong}>
                                        <path d="M7.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z" />
                                        <path d="M15.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C8.713 12.69 8 12.345 8 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z" />
                                    </svg>
                                    <button onClick={this.playOrPause} className="play current-btn">
                                        {
                                            (!pause) ?
                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" onClick={this.playOrPause} className="play current-btn" viewBox="0 0 16 16">
                                                    <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" /></svg>
                                                :
                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
                                                    <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" />
                                                </svg>
                                        }
                                    </button>
                                    <svg xmlns="http://www.w3.org/2000/svg" cursor=" pointer" width="28" height="28" fill="currentColor" className="bi bi-fast-forward-fill" viewBox="0 0 16 16"
                                        onClick={this.nextSong}>
                                        <path d="M7.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z" />
                                        <path d="M15.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C8.713 12.69 8 12.345 8 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z" />
                                    </svg>
                                </div >

                                <div className="svg-groups">
                                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => this.handleSearch()} style={{ cursor: " pointer" }} opacity="40%" width="23" height="15" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                    </svg>

                                    <svg xmlns="http://www.w3.org/2000/svg" cursor=" pointer" opacity="40%" width="23" height="19" fill="currentColor" className="bi bi-volume-up-fill" viewBox="0 0 16 16"
                                        onClick={() => this.handleVolume()} >
                                        <path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z" />
                                        <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z" />
                                        <path d="M8.707 11.182A4.486 4.486 0 0 0 10.025 8a4.486 4.486 0 0 0-1.318-3.182L8 5.525A3.489 3.489 0 0 1 9.025 8 3.49 3.49 0 0 1 8 10.475l.707.707zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z" />


                                    </svg>
                                    {this.state.showVolume ? (
                                        <div className="volume">
                                            <input
                                                id="volume"
                                                type="range"
                                                min="0" max="5"
                                                value={this.state.value}
                                                onChange={this.handleChangevolume}
                                                step="1" />

                                        </div>
                                    ) : null
                                    }

                                </div >
                            </div>

                            {this.state.showSearchbox ? (
                                <div className="searchbar">
                                    <div className="alist">
                                        <input type="text" placeholder="search..." fontSize="smaller" onChange={() => this.inputHandler()}></input>
                                        <input type="search" className="input" onChange={this.filter} variant="outlined" fullWidth label="Search" placeholder="search..." />
                                    </div>
                                </div>
                            ) : null
                            }
                            <div className="list">
                                <div className="songsPage row m-0">
                                    <DragDropContext onDragEnd={this.onDragEnd}>
                                        <Droppable droppableId="droppable">
                                            {(provided, snapshot) => (
                                                <div
                                                    {...provided.droppableProps}
                                                    ref={provided.innerRef}
                                                // style={getListStyle(snapshot.isDraggingOver)}
                                                >

                                                    {this.state.musicList.map((song, index) => (
                                                        <Draggable key={song.id} draggableId={song.id} index={index}>
                                                            {(provided, snapshot) => (
                                                                <div ref={provided.innerRef} {...provided.draggableProps} >
                                                                    <div className="songlist" key={song.id} onClick={() => {
                                                                        this.setState(
                                                                            {
                                                                                currentsong: { ...song, current: 0 }
                                                                            }
                                                                        )
                                                                    }}>
                                                                        <span style={{ padding: "2rem .5rem" }} {...provided.dragHandleProps}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-horizontal" viewBox="0 0 16 16">
                                                                                <path d="M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                                            </svg>
                                                                        </span>
                                                                        <img className="songimage" src={song.img}></img>
                                                                        <div className="songdesc">
                                                                            <p href={song.hreff} style={{ lineHeight: "17px", fontSize: "11px" }}>{song.name}</p>
                                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}><p href={song.hreff} style={{ color: "gray" }}>{song.author}</p>
                                                                                <p className="songsduration">{song.duration}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="songtime">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" cursor=" pointer" width="20" height="20" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16" >
                                                                                <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )

    }
}